import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import accountManagement from '../../../../apis/accountManagement';
import { CONFIG } from '../../../../config';
import ModalEdit from './ModalEdit';
import "datatables.net-bs4/css/dataTables.bootstrap4.css";

const $ = require('jquery');
$.Datatable = require('datatables.net-bs4');

const columns = [
    {
        title: 'No.',
        width: '5%',
        data: null,
    },
    {
        title: 'Nama Kelas',
        width: '18%',
        data: 'kodeTahunAjaran'
    },
    {
        title: 'Nama Kelas Pararel',
        width: '30%',
        data: 'namaKelasParalel'
    },
    {
        title: 'Wali Kelas',
        width: '35%',
        data: 'namaGuru'
    },
    {
        title: 'Aksi',
        width: '12%',
        data: null
    }
];

export default class TableKelas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSearch: false,
            isShowModalDelete: false,
            dataEditKelas: [],
        }

        this.fetchDataById = this.fetchDataById.bind(this);
    }

    componentDidMount() {
        this.$el = $(this.el);
        this.$el.DataTable({
            // dom: '<"top"ip>rt<"bottom"fl><"clear">',
            // dom: '<"data-table-wrapper"t>',
            // dom: 'Bfrtip',
            destroy: true,
            bProcessing: true,
            data: this.props.dataKelas,
            columns,
            columnDefs: [
                {
                    targets: 0,
                    searchable: false,
                    render: function ( data, type, full, meta ) {
                        return (meta.row + 1);
                    }
                },
                {
                    targets: 4,
                    searchable: false,
                    orderable: false,
                    createdCell: (td, cellData, rowData, row, col) =>
                    ReactDOM.render(
                        <>{this.columnsOpsi(cellData.idSekolah, cellData.idKelasParalel)}</>,
                    td),
                }
            ],
        });
    }

    componentWillUpdate() {
        this.$el = $(this.el);
        this.$el.DataTable({
            destroy: true,
            bProcessing: true,
            data: this.props.dataKelas,
            columns,
            columnDefs: [
                {
                    targets: 0,
                    searchable: false,
                    render: function ( data, type, full, meta ) {
                        return (meta.row + 1);
                    }
                },
                {
                    targets: 4,
                    searchable: false,
                    orderable: false,
                    createdCell: (td, cellData, rowData, row, col) =>
                    ReactDOM.render(
                        <>{this.columnsOpsi(cellData.idSekolah, cellData.idKelasParalel)}</>,
                    td),
                }
            ]
        });
    }

    shouldComponentUpdate(nextProps, nextState) {        
        if (this.props.dataKelas !== nextProps.dataKelas) {
            this.$el = $(this.el);
            this.$el.DataTable({
                destroy: true,
                bProcessing: true,
                data: nextProps.dataKelas,
                columns,
                columnDefs: [
                    {
                        destroy: true,
                        targets: 0,
                        searchable: false,
                        render: function ( data, type, full, meta ) {
                            return (meta.row + 1);
                        }
                    },
                    {
                        targets: 4,
                        searchable: false,
                        orderable: false,
                        createdCell: (td, cellData, rowData, row, col) =>
                        ReactDOM.render(
                            <>{this.columnsOpsi(cellData.idSekolah, cellData.idKelasParalel)}</>,
                        td),
                    }
                ],
            });
        }

        if (this.props.kelasDropdown !== nextProps.kelasDropdown) {
            return true;
        }

        if (this.props.guruDropdown !== nextProps.guruDropdown) {
            return true;
        }
        
        if (this.state.dataEditKelas !== nextState.dataEditKelas) {
            return true;
        }

        if (this.props.statusModalEdit !== nextProps.statusModalEdit) {
            return true;
        }

        return false;
    }

    columnsOpsi(a, b) {
        return(
            <>
                <button className="btn btn-outline-primary" name="modalUpdate" data-toggle="modal" data-target="#editKelas" data-backdrop="static" data-keyboard="false" title="edit" onClick={this.fetchDataById.bind(this, a, b)}>
                    <li className="fa fa-pencil"></li>
                </button>
                {/*&nbsp;
                 <button className="btn btn-outline-danger" name="modalDelete" data-toggle="modal" data-target="#deleteKelas" data-backdrop="static" data-keyboard="false" title="hapus" onClick={this.handleDelete.bind(this, a, b)}>
                    <li className="fa fa-trash"></li>
                </button> */}
            </>
        );
    }

    handleDelete(a, b) {
        this.props.onChange('isShowDelete', true);
        this.props.onChange('idSekolah', a);
        this.props.onChange('idKelasParalel', b);
        this.props.clearAlert();
    }

    fetchDataById = async (a, b) => {
        this.props.onChange('isShowEdit', true);
        this.props.clearAlert();
        this.setState({
            isSearch: true
        });

        const fetchById = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_BY_ID_KELAS_PARAREL + a + '/' + b)
        .catch(function(error) {
            console.log('===== TableKelas.js Fetch Kelas By Id =====', error)
        });
        
        this.setState({
            dataEditKelas: fetchById.data.data[0],
            isSearch: false
        });
        console.log('===== TableKelas.js Result Fetch Kelas By Id =====', this.state.dataEditKelas);
    }

    render() {
        const kelasDropdown = this.props.kelasDropdown;
        const guruDropdown = this.props.guruDropdown;
        
        if(!kelasDropdown && !guruDropdown) {
            return null;
        }

        return (
            <>
                <div>
                    <table className="table table-striped table-bordered" id="listKelasPararel" style={{width: "100%"}} ref={el => this.el = el}/>
                </div>

                <ModalEdit
                    statusModal={this.props.statusModalEdit}
                    kelasDropdown={kelasDropdown}
                    guruDropdown={guruDropdown}
                    dataEdit={this.state.dataEditKelas}
                    onChange={this.props.onChange.bind(this)}
                    eventSubmit={this.props.eventSubmit}
                />
            </>
        )
    }
}